import React, { useEffect, useState } from "react";
import "../../Css/CustomerDashboard_new.css";
import { Outlet, useLocation } from "react-router-dom";
import CustomerDashBoardNavbar from "../../../components/CustomerDashBoard/CustomerDashBoardNavbar";
import CustomerDashboardSidebar from "../../../components/CustomerDashBoard/CustomerDashBoardSidebar";
import DraggableWhatsAppIcon from "../../../components/CustomerDashBoard/DraggableWhatsAppIcon";
import SEO from "../../../components/SEO";

const CustomerDashboard = () => {
  const [selectedNavToggle, setSelectedNavToggle] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollContainer = document.querySelector(".dashboard-scroll-container");
    if (scrollContainer) {
      scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [pathname]);

  return (
    <div className="customer-dashboard-root">
      <SEO
        title="Customer Dashboard | Kirkos Car Rental"
        description="Manage your bookings, view trip history, and update your profile in the Kirkos customer dashboard."
        keywords="customer dashboard, kirkos account, manage car rental, booking history"
      />
      <div className="dashboard-mesh-bg"></div>
      
      {/* Sidebar Overlay for Mobile */}
      <div 
        className={`sidebar-overlay ${!selectedNavToggle ? "active" : ""}`}
        onClick={() => setSelectedNavToggle(true)}
      ></div>

      <CustomerDashboardSidebar
        selectedNavToggle={selectedNavToggle}
        setSelectedNavToggle={setSelectedNavToggle}
      />

      <div className="dashboard-main-area">
        <header className="dashboard-header">
          <CustomerDashBoardNavbar
            selectedNavToggle={selectedNavToggle}
            setSelectedNavToggle={setSelectedNavToggle}
          />
        </header>

        <main className="dashboard-scroll-container" id="dashboardMain">
          <div className="dashboard-outlet-wrapper">
            <Outlet />
          </div>
        </main>
        
        <DraggableWhatsAppIcon />
      </div>
    </div>
  );
};

export default CustomerDashboard;
